<template>
  <div class="main-wrap">
    <action-bar title>
      <span style="font-weight: bold;" slot="left">{{webinfo}}</span>
      <span class="logout" slot="right" @click="logouts">退出</span>
    </action-bar>

    <div class="horn-wrap">
      <i class="icon icon-horn"></i>
      <marquee scrollamount="4">
            <span
              style="margin-right:10px"
              :key="'horn' + ind"
              v-for="(horn, ind) in horns"
              class="horn horn-item"
              @click="showContent(horn)"
            >{{horn.content}}</span>
      </marquee>
    </div>

    <div class="v-main" >
      <user-wrap v-if="userinfo" :info="userinfo"></user-wrap>

      <tab-bar></tab-bar>

      <card-item
        class="carItem"
        :item="item"
        v-for="(item, index) in datalist"
        :key="'item' + index"
      ></card-item>
    </div>
    <div class="agreement" ref="agreement" style="display:none">
        <table border="1" style="border-collapse: collapse;">
          <tr>
              <!--<th>时间</th>
              <th>标题</th>-->
              <th>公告内容</th>
          </tr>
          <tr v-for="(li, index) in horns" :key="'ag' + index">
            <!--<td>{{li.send_time | formatDate}}</td>
            <td>{{li.title}}</td>-->
            <td>{{li.content}}</td>
          </tr>
        </table>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Vue from 'vue';
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css';
Vue.prototype.$layer = layer(Vue);
import ActionBar from "@/components/action-bar";
import UserWrap from "@/components/user-info";
import TabBar from "@/components/tab-bar";
import CardItem from "./card-item";
import { getProfile } from "@/service/user";
import { getNotices } from "@/service/home";
import {getWebInfo} from "@/service/user";
import {
  getLotteryTypes,
  getNewLotteryRes,
  getDownCount
} from "@/service/lottery";

export default {
  name: "v-main",
  components: {
    ActionBar,
    UserWrap,
    CardItem,
    TabBar
  },
  filters: {
      formatDate: function (value) {
        let date = new Date(parseInt(value+"000"));
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      }
  },
  data() {
    return {
      webinfo:"",
      profile: [],
      userinfo: null,
      datalist: [],
      horns: []
    };
  },

  async created() {
  
   // this.horns = await getNotices().data;
    getNotices().then(res => {
      this.horns = res.data;
    });
    getProfile().then(res => {
      if (res.result == "ok") {
        this.profile = res.data.profile;
        this.userinfo = res.data.userinfo;
        //console.log("这里用户信息", res);
      }
    });

    this.datalist = await getDownCount(0);
    //console.log("datalist", this.datalist);
    this.getWebinfo();
  },

 

  methods: {

    ...mapActions("root", ["logout"]),

    logouts() {
      this.logout();
      this.$router.push("/login");
    },
     async getWebinfo(){
            this.webinfo = await getWebInfo();
      },
      showContent(notify){
        this.$layer.open({
          type: 0,
          title: '公告',
          skin: 'layui-layer-rim', //加上边框
          area: ['95%','95%'], //宽高
          shade: true,
          btn: '确定',
          content: this.$refs.agreement.innerHTML
        });
      }
  }
};
</script>

<style scoped lang="less">
th, td {
    border: 1px solid #aaa;
}
.main-wrap {
  background-color: #f5f5f5;
  .logout {
    color: #fff;
    height: 30px;
    padding: 10px 30px;
    font-size: 26px;
    background: #f60;
    border-radius: 6px;
  }
  .horn-wrap {
    height: 60px;
    line-height:60px;
    position: relative;
    box-sizing: border-box;
    padding-left: 60px;
    border-bottom: 1px solid #dcdcdc;
    background-color: #fff;
    .icon-horn {
      top: 50%;
      left: 15px;
      width: 32px;
      height: 32px;
      position: absolute;
      margin-top: -16px;
      background: url("/static/images/laba.png") no-repeat center center;
      background-size: contain;
    }
    .mini-horn {
      color: #fd726f;
      width: 100%;
      height: 100%;
      font-size: 32px;
      border-radius: 0;
      background-color: #fff;
      .horn-item {
        height: 100%;
        width: 100%;
      }
    }
  }
  .v-main {
    margin-bottom: 13vw;
    .carItem {
      margin: 6px 15px 0 15px;
    }
    .carItem:nth-child(3) {
      margin-top: 15px;
    }
  }
  
}
</style>



// WEBPACK FOOTER //
// src/pages/home/main/index.vue